import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: '72px',
  background: '#FFFFFF',

  '& .MuiTabs-indicator': {
    background: '#FF6E7214',
    height: '80%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px',
    display: 'flex',
    textDecoration: 'none',
    flexDirection: 'column',
    gap: '10px',
    borderRadius: '10px',
    border: '1px solid #FF6E72',
    boxShadow: '0px 4px 4px 0px rgba(255, 110, 114, 0.24)',
  },
  '& .MuiTab-root': {
    color: '#111927',
    fontSize: '16px',
    fontWeight: '400',
    textAlign: 'center',
    lineHeight: 'normal',
  },
  '& .Mui-selected': {
    textDecoration: 'none',
    color: '#111927',
    fontSize: '16px',
    fontWeight: '400',
    textAlign: 'center',
    lineHeight: 'normal',
  },
  '& .MuiTabs-flexContainer': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '80px',
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  height: '100px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
}));
